import css from 'styled-jsx/css';

export default css`
  .s-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 11px;
  }
  .size {
    background: var(--background-utils);
    border: 1px solid var(--grey-lighter);
    box-sizing: border-box;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
    cursor: pointer;
  }
  .size-background {
    background: var(--social-button);
    border-radius: 50%;
    height: 48px;
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .size-disabled {
    background: var(--disabled);
  }
  .size-selected {
    border: none;
    height: 42px;
    width: 42px;
  }
  .size span {
    font-size: 11px;
  }
`;
